// Throttle function that limits how often a function can be called
export function throttle(func, delay) {
  let lastCall = 0;
  let timeout = null;
  
  function throttled(...args) {
    const now = Date.now();
    
    if (now - lastCall >= delay) {
      lastCall = now;
      func.apply(this, args);
    } else {
      // Update with the latest args but still respect the throttle delay
      clearTimeout(timeout);
      timeout = setTimeout(() => {
        lastCall = Date.now();
        func.apply(this, args);
      }, delay - (now - lastCall));
    }
  }
  
  // Add cancel method to clean up pending timeouts
  throttled.cancel = function() {
    clearTimeout(timeout);
    timeout = null;
  };
  
  return throttled;
}

// Debounce function for comparison (delays execution until after wait period)
export function debounce(func, wait) {
  let timeout;
  
  function debounced(...args) {
    clearTimeout(timeout);
    timeout = setTimeout(() => func.apply(this, args), wait);
  }
  
  // Add cancel method to clean up pending timeouts
  debounced.cancel = function() {
    clearTimeout(timeout);
    timeout = null;
  };
  
  return debounced;
}